import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { modalWindows, auth, user } from 'src/actions';
import FORM_STATES from 'src/constants/authFormsStates';
import eventManager, { AUTH_SUCCESS, AUTH_FAILED, AUTHORIZE_USER } from 'src/utils/eventManager';
import { setAuthCookie } from 'src/utils/cookies';
import Modal from '../Modal/ModalWrapper';
import ResetPassword from '../Modal/ResetPassword';

import Login from './Login';
import Register from './Register';


import './authorization.scss';

// Making promise based auth, same as bootstrap
// Resolving if user is|would authenticate; else - rejecting promise.
export const AuthorizeUser = () => {
  return new Promise((res, rej) => {
    eventManager.on(AUTH_SUCCESS, () => {
      eventManager.off(AUTH_SUCCESS);
      res();
    });
    eventManager.on(AUTH_FAILED, () => {
      eventManager.off(AUTH_FAILED);
      rej();
    });
    eventManager.emit(AUTHORIZE_USER);
  });
}

// Main class
class Authorization extends Component {
  componentDidMount() {
    eventManager.on(AUTHORIZE_USER, () => {
      if (this.isAuthenticated()) {
        eventManager.emit(AUTH_SUCCESS);
        this.closeModal();
      } else {
        this.props.openLoginModal();
      }
    }) 
  }

  hasPropUpdated = (prevProps, propName) => {
    return prevProps[propName] !== this.props[propName];
  }

  isAuthenticated = () => {
    return this.props.username && this.props.isAuthenticated;
  }

  fetchUserData = () => {
    return this.props.getUserProfile()
      .catch(() => {
        console.error('Auth was retrieved but username wasnt - logging out.');
        toast.error("Что-то пошло не так :(");
        this.props.logoutUser();
      })
  }

  loginUser = (name, pwd, token) => {
    return this.props.loginUser(name, pwd, token)
      .then((res) => {
        setAuthCookie(res.data.token);
        return this.fetchUserData();
      })
      .then((res) => {
        this.closeModal();
        return res;
      });
  }

  registerUser = (name, password, email) => {
    return this.props.registerUser(name, password, email);
  }

  closeModal = () => {
    this.props.updateActiveForm(FORM_STATES.LOGIN);
    this.props.closeLoginModal();
    const eventName = this.isAuthenticated() ? AUTH_SUCCESS : AUTH_FAILED;
    eventManager.emit(eventName);
  }

  getActiveFormDOM() {
    const { activeForm, requestInProgress } = this.props;
    if (activeForm === FORM_STATES.RESET_PWD) {
      return (
        <ResetPassword closeModal={() => this.props.updateActiveForm(FORM_STATES.LOGIN)}/>
      );
    } else if (activeForm === FORM_STATES.REGISTER) {
      return (
        <Register formStates={FORM_STATES} requestInProgress={requestInProgress}
          onFormStateChange={this.props.updateActiveForm} onSubmit={this.registerUser} />
      );
    }
    return (
      <Login formStates={FORM_STATES} requestInProgress={requestInProgress}
        onFormStateChange={this.props.updateActiveForm} onSubmit={this.loginUser} />
    );
  }

  render() {
    return (
      <Modal
        isOpened={this.props.isLoginModalOpened}
        onClose={this.closeModal}
      >
        {this.getActiveFormDOM()}
      </Modal>
    );
  }
}

Authorization.propTypes = {
  isLoginModalOpened: PropTypes.bool.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  requestInProgress: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
  activeForm: PropTypes.string.isRequired,
  openLoginModal: PropTypes.func.isRequired,
  closeLoginModal: PropTypes.func.isRequired,
  loginUser: PropTypes.func.isRequired,
  logoutUser: PropTypes.func.isRequired,
  registerUser: PropTypes.func.isRequired,
  getUserProfile: PropTypes.func.isRequired,
  updateActiveForm: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    isLoginModalOpened: state.modalWindows.loginOpened,
    isAuthenticated: state.auth.isAuthenticated,
    requestInProgress: state.auth.inProgress || state.user._inProgress,
    username: state.user.username,
    activeForm: state.auth.activeForm,
  };
}
export default connect(mapStateToProps, {
  openLoginModal: modalWindows.openLoginModal,
  closeLoginModal: modalWindows.closeLoginModal,
  loginUser: auth.login,
  logoutUser: auth.logout,
  registerUser: auth.register,
  getUserProfile: user.getUserProfile,
  updateActiveForm: auth.updateActiveForm,
})(Authorization);




// WEBPACK FOOTER //
// ./src/components/Authorization/index.js